import { instance as axios } from './baseUrl'

export const fetchOfferBySchool = (id) => axios.get(`offers/school/${id}`);
